import { createSlotRecipe } from './runtime';

const numberFieldConfig = {"name":"numberField","slots":["root","group","stepper","stepperButton"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const numberField = /* @__PURE__ */ createSlotRecipe(numberFieldConfig)